import { json } from "stream/consumers";
import {
  AgentCreationModel,
  AgentDetailModel,
  AgentUpdateModel,
} from "../models/agent.model";
import { axiosClient } from "./http-client.service";

export async function createAgent(
  agentData: AgentCreationModel
): Promise<AgentDetailModel> {
  const response = await axiosClient.post("/agent", agentData);
  return response.data;
}

export async function getAgents(): Promise<AgentDetailModel[] | null> {
  const response = await axiosClient.get("/agent/all");
  return response.data;
}

export async function getAgentById(agentId: string): Promise<AgentDetailModel> {
  const response = await axiosClient.get(`/agent/${agentId}`);
  return response.data;
}

export async function deleteAgent(agentId: string): Promise<void> {
  await axiosClient.delete(`/agent/${agentId}`);
}

export async function updateAgentDetails(
  agentId: string,
  agentData: Partial<AgentDetailModel>
): Promise<AgentDetailModel> {
  const convertedAgentData: Partial<AgentUpdateModel> = JSON.parse(
    JSON.stringify(agentData)
  );

  convertedAgentData.informationToCollect = agentData.informationToCollect?.map(
    (info) => {
      if (typeof info === "string") return info;
      return info.id;
    }
  );

  const response = await axiosClient.patch(
    `/agent/${agentId}`,
    convertedAgentData
  );
  return response.data;
}
